
import { useState, useEffect } from "react";
import { usePermissions } from "@/context/PermissionsContext";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const useNotificationPermissions = () => {
  const { hasPermission } = usePermissions();
  const { user } = useAuth();
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  useEffect(() => {
    // Management users always have full permissions
    if (user?.role === "management") {
      console.log("NotificationDetail - management user detected, granting full permissions");
      setCanEdit(true);
      setCanDelete(true);
      return;
    }

    // For other roles, check permissions normally
    const writeAccess = hasPermission("notifications", "write");
    const deleteAccess = hasPermission("notifications", "delete");
    console.log("NotificationDetail - permission check results:", { write: writeAccess, delete: deleteAccess });
    setCanEdit(writeAccess);
    setCanDelete(deleteAccess);
  }, [hasPermission, user]);

  const checkEditPermission = () => {
    // Management users always have edit permission
    if (user?.role === "management") return true;
    
    if (!canEdit) {
      toast.error("Je hebt geen rechten om meldingen te bewerken");
      return false;
    }
    return true;
  };

  const checkDeletePermission = () => {
    // Management users always have delete permission
    if (user?.role === "management") return true;
    
    if (!canDelete) {
      toast.error("Je hebt geen rechten om meldingen te verwijderen");
      return false;
    }
    return true;
  };

  return {
    canEdit,
    canDelete,
    checkEditPermission,
    checkDeletePermission
  };
};
